export var momAttachFilesMapper = function (data) {
    var _a;
    var result = {
        currentpage: data.currentpage,
        pagesize: data.pagesize,
        totalpages: data.totalpages,
        totalitems: data.totalitems,
        data: (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({
            createdOn: item === null || item === void 0 ? void 0 : item.createdOn,
            eTag: item.eTag,
            fileName: item.fileName,
            fileSize: (item === null || item === void 0 ? void 0 : item.fileLengthInKB) > 999
                ? "".concat(((item === null || item === void 0 ? void 0 : item.fileLengthInKB) / 1024).toFixed(1), " MB")
                : "".concat(item === null || item === void 0 ? void 0 : item.fileLengthInKB, " KB"),
            checked: false,
            fileSizeInKB: item === null || item === void 0 ? void 0 : item.fileLengthInKB,
        }); }),
    };
    return result;
};
